import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-create-comps-li-modal",
  templateUrl: "./create-comps-li-modal.component.html",
  styleUrls: ["./create-comps-li-modal.component.scss"],
})
export class CreateCompsLIModalComponent {
  @Input() addColTableData: Array<any>;
  @Input() stdLineItems: Array<any>;
  @Input() periodsWithAvailableDataForPopup: any;
  @Input() max;
  @Input() createSource;
  @Input() tickers: Array<string>;
  @Input() filterData: any;
  @Input() yearTypeData: any;
  @Input() openedForAddIn = false;
  @Input() marketItemsData: Array<any>;
  @Output() saveYearType = new EventEmitter();
  @Output() saveLineItems = new EventEmitter();

  radioType: string;
  // constructor() { }

  // ngOnInit() {
  // }

  saveCompsYearType(params) {
    this.saveYearType.emit(params);
  }

  saveCompsLineItems(params) {
    this.saveLineItems.emit(params);
  }

  handlePeriodApply(params) {
    this.saveYearType.emit(params);
  }
}
